export const _en = {
    materialResourceActivity: {
        alert: "The session « {{planningName}} » part of training course « {{courseName}} » don't have material resource:  « {{ressourceName}}  » ",
        alertNeed: "The session « {{planningName}} » of  training course « {{courseName}} » don't have the requirement of « {{ressourceType}} » "
    },
    humanResourceActivity: {
        alert: "The session “{{planningName}}” of the course “{{courseName}}” does not have the human resource “{{ressourceName}}”.",
        alertNeed: "The session “{{planningName}} of the internship “{{courseName}}” does not have the human resource “{{ressourceName}}”."
    },
    prerequisites: {
        alertChain: "The session “{{planningName}}” of the course “{{courseName}}” does not meet the prerequisite “{{prerequisiteName}}” of the session “{{activityName}}”.",
        alert: "The session “{{planningName}}” of the course “{{courseName}}” does not meet the prerequisite “{{prerequisiteName}}”."
    }
};

export const _fr = {
    materialResourceActivity: {
        alert: "La séance «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne dispose pas la ressource matérielle  «<i> <b>{{ressourceName}}</b></i> ».",
        alertNeed: "La séance «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne dispose pas le besoin de la ressource matérielle «<i> <b>{{ressourceName}}</b></i> »."
    },
    humanResourceActivity: {
        alert: "La séance «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne dispose pas de la ressource humaine  «<i> <b>{{ressourceName}}</b></i> ».",
        alertNeed: "La séance «<i> <b>{{planningName}} du stage «<i> <b>{{courseName}}</b></i> » ne dispose pas de la ressource humaine «<i> <b>{{ressourceName}}</b></i> »."
    },
    prerequisites: {
        alertChain: "La séance «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne respecte pas le prérequis «<i> <b>{{prerequisiteName}}</b></i> » sur la séance «<i> <b>{{activityName}}</b></i> ».",
        alert: "La séance «<i> <b>{{planningName}}</b></i> » du stage «<i> <b>{{courseName}}</b></i> » ne respecte pas le prérequis «<i> <b>{{prerequisiteName}}</b></i> »."
    }
};